<template>
    <div class="bg-gray-900 text-white min-h-screen flex flex-col">
        <header class="flex justify-between items-center p-4">
            <div class="text-xl font-bold">yally</div>
            <nav>
                <NuxtLink to="/explore-events" class="mr-4 text-sm">Explore Events</NuxtLink>
                <NuxtLink to="/sign-in" class="text-sm">Sign In</NuxtLink>
            </nav>
        </header>

        <main class="flex-grow flex justify-center items-center">
            <div class="login-card bg-gray-800 p-8 rounded-lg shadow-lg max-w-md w-full">
                <div class="icon mb-4">
                    <!-- Add your icon here -->
                    <Icon name="lucide:user" class="text-4xl" />
                </div>
                <h1 class="text-2xl font-bold mb-2">Welcome to yally</h1>
                <p class="mb-6">Please sign in or sign up below.</p>

                <form @submit.prevent="handleSubmit">
                    <div class="mb-4">
                        <label for="email" class="block mb-2">Email</label>
                        <div class="flex">
                            <input type="email" id="email" v-model="email" placeholder="you@email.com"
                                class="flex-grow bg-gray-700 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" />
                        </div>
                    </div>

                    <div class="mb-4">
                        <label for="password" class="block mb-2">Password</label>
                        <div class="flex">
                            <input type="password" id="password" v-model="password" placeholder="********"
                                class="flex-grow bg-gray-700 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" />
                        </div>
                    </div>

                    <button type="submit"
                        class="w-full bg-white text-gray-900 py-2 rounded-lg font-semibold hover:bg-gray-200 transition-colors">
                        Continue with Email
                    </button>
                </form>

                <button
                    class="w-full mt-4 bg-gray-700 text-white py-2 rounded-lg font-semibold hover:bg-gray-600 transition-colors flex items-center justify-center">
                    <Icon name="lucide:google" class="mr-2" />
                    Sign in with Google
                </button>

                <!-- <NuxtLink to="/sign-up" class="block mt-4 text-center text-sm text-blue-500 hover:underline">
                    Create an account
                </NuxtLink> -->
            </div>
        </main>
    </div>
</template>

<script setup lang="ts">
const route = useRoute()
const router = useRouter()
const { signIn } = useAuth()
const userStore = useUserStore()

const email = ref('')
const password = ref('')

const handleSubmit = async () => {
    const credentials = {
        email: email.value,
        password: password.value
    }
    try {
        await signIn(credentials, { callbackUrl: '/home' })

        // Get user data directly from auth
        const { data } = useAuth()

        if (data.value?.user) {
            userStore.setUser({
                fullName: data.value.user.fullName,
                email: data.value.user.email,
                username: data.value.user.username
            })
        }

        // Handle redirect
        const redirectPath = route.query.redirect as string
        if (redirectPath) {
            await router.push(redirectPath)
        } else {
            await router.push('/home')
        }
    } catch (error) {
        console.error(error)
    }
}
</script>
